import ObjectListController from "./object_list_controller"

export default class CompaniesObjectListController extends ObjectListController {
  connect() {
    super.connect()
  }

  onAdd(companies) {
    this.companies = companies
    window.Turbo.visit(this.addItemUrlValue, { frame: "modal" })
  }
}
